function ec2Metricas() {
  console.log("ec2Metricas");
}

export default ec2Metricas;
